import axios from 'axios';
import { START_MODE } from './constants';

export const callApi = (endpoint, method = 'GET', data, options) => {
     let headers = null;

     let urlApi = process.env.REACT_APP_API || 'https://trainingplatform.local/api/v1';

     switch (process.env.REACT_APP_START_MODE) {
          case START_MODE.K8S:
               urlApi = 'https://trainingplatform.local/api/v1';
               break;
          case START_MODE.DOCKER_COMPOSE:
               urlApi = process.env.REACT_APP_API;
               break;

          default:
               break;
     }

     switch (process.env.REACT_APP_ENV) {
          case 'prod':
               urlApi = 'https://training.api.cams-care.com/api/v1';
               break;

          case 'staging':
               urlApi = 'https://trainingplatform-staging.hostedstaging.com/api/v1';
               break;

          case 'development':
               urlApi = 'https://training-dev.api.cams-care.com/api/v1';
               break;
          default:
               break;
     }

     const _options = {
          url: `${urlApi}/${endpoint}`,
          method,
          withCredentials: true,
     };

     if (headers) {
          _options.headers = headers;
     }

     if (options && Object.keys(options).length) {
          Object.assign(_options, options);
     }

     if (data !== null && typeof data === 'object') {
          _options.data = data;
     }

     return axios(_options)
          .then((response) => response)
          .catch((error) => error.response);
};
